import { render, staticRenderFns } from "./appDetail.vue?vue&type=template&id=b33a800c&scoped=true&"
import script from "./appDetail.vue?vue&type=script&lang=js&"
export * from "./appDetail.vue?vue&type=script&lang=js&"
import style0 from "./appDetail.vue?vue&type=style&index=0&id=b33a800c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33a800c",
  null
  
)

component.options.__file = "appDetail.vue"
export default component.exports